// partners/adminView/pages/A10_AdminComingSoonInterest.jsx

import { useState, useEffect, useRef } from "react";
import {
  useGetAdminInterestQuery,
  useExportInterestCSVQuery,
} from "../../../apis/adminApiSlice";
import AdminLayout from "./A0_AdminLayout";
import { capturePartnerEvent } from "../../../utils/analytics";

export default function AdminComingSoonInterest() {
  const [track,      setTrack]      = useState("");
  const [doExport,   setDoExport]   = useState(false);

  const { data, isLoading } = useGetAdminInterestQuery({ track });
  const { data: csvText }   = useExportInterestCSVQuery({ track }, { skip: !doExport });

  const entries = data?.results || data || [];
  const viewedRef = useRef(false);

  useEffect(() => {
    if (!isLoading && !viewedRef.current) {
      viewedRef.current = true;
      capturePartnerEvent("partner_admin_interest_viewed");
    }
  }, [isLoading]);

  const handleCSV = () => {
    capturePartnerEvent("partner_admin_interest_exported", { track: track || undefined });
    setDoExport(true);
    if (csvText) {
      const blob = new Blob([csvText], { type: "text/csv" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href = url;
      a.download = "mnf_partner_interest.csv";
      a.click();
      URL.revokeObjectURL(url);
      setDoExport(false);
    }
  };

  return (
    <AdminLayout>
      <div className="flex items-center justify-between mb-6">
        <h1 className="font-poppins text-2xl font-bold">Coming Soon — Interest List</h1>
        <button
          onClick={handleCSV}
          className="text-xs font-poppins font-semibold px-4 py-2 rounded-mnf-pill border border-white/20 text-mnf-text-secondary hover:border-mnf-cyan/40 transition-colors"
        >
          Export CSV
        </button>
      </div>

      <div className="mb-6">
        <select
          value={track}
          onChange={(e) => {
            const val = e.target.value;
            setTrack(val);
            capturePartnerEvent("partner_admin_interest_filtered", { track: val || undefined });
          }}
          className="bg-mnf-dark-3 border border-white/[0.08] text-mnf-text-secondary rounded-mnf px-3 py-2 text-sm focus:outline-none focus:border-mnf-cyan"
        >
          <option value="">All tracks</option>
          <option value="school_reseller">Film School Reseller</option>
          <option value="power_partner">Strategic Power Partner</option>
          <option value="ott_integration">OTT Integration Partner</option>
        </select>
      </div>

      {isLoading ? <div className="text-mnf-text-muted text-sm">Loading...</div> : (
        <div className="bg-mnf-dark-2 border border-white/[0.08] rounded-mnf-lg overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-mnf-dark-3 text-mnf-text-muted text-xs uppercase tracking-wider">
              <tr>
                <th className="px-5 py-3 text-left">Name</th>
                <th className="px-5 py-3 text-left">Email</th>
                <th className="px-5 py-3 text-left">Track</th>
                <th className="px-5 py-3 text-left">Organization</th>
                <th className="px-5 py-3 text-left">Registered</th>
                <th className="px-5 py-3 text-left">Notified</th>
              </tr>
            </thead>
            <tbody>
              {entries.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-5 py-8 text-center text-mnf-text-muted">
                    No interest registrations yet.
                  </td>
                </tr>
              )}
              {entries.map((e, i) => (
                <tr key={i} className="border-t border-white/[0.04] hover:bg-mnf-dark-3 transition-colors">
                  <td className="px-5 py-3 font-semibold">{e.name || "—"}</td>
                  <td className="px-5 py-3 text-mnf-text-secondary">{e.email}</td>
                  <td className="px-5 py-3 text-xs text-mnf-text-muted capitalize">
                    {e.track_type?.replace(/_/g, " ")}
                  </td>
                  <td className="px-5 py-3 text-xs text-mnf-text-muted">{e.organization || "—"}</td>
                  <td className="px-5 py-3 text-xs text-mnf-text-muted">
                    {e.registered_at
                      ? new Date(e.registered_at).toLocaleDateString("en-IN", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })
                      : "—"}
                  </td>
                  <td className="px-5 py-3">
                    <span
                      className={`text-xs font-semibold ${
                        e.notified ? "text-mnf-success" : "text-mnf-text-muted"
                      }`}
                    >
                      {e.notified ? "Yes" : "No"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </AdminLayout>
  );
}
